export class FormaPagamentoModel {
    constructor() {
        this.Sucesso = false;
    } 

    public Sucesso: boolean;
    public Mensagem: string;

    public Relacao: DetalheFormaPagamentoModel[];
}

export class DetalheFormaPagamentoModel {
    public Codigo: number;
    public Nome: string;
    public PermiteTroco: boolean;
    public ValorTotal: number;
    public ValorPagamento: number;
    public PermitePagamentoOnline: boolean;
    public ValorMinimoRequisicao: number;
    public CodigoPagamento: number;
    public CodigoPlataformaPagamento: number;
    public PagamentoOnline: boolean;
    public FoiPago: boolean;
    public Selecionado: boolean;
    public RetornarTroco: boolean;
    public TempoExpiracaoEmMinutos: number;
}